(function () {
  'use strict';
  const records = new Set();
  const prepared = new WeakSet();
  let previousConsent;
  const copy = document.documentElement.lang.startsWith('fr')
    ? { load: 'Charger la vidéo YouTube', play: 'Lire la vidéo' }
    : document.documentElement.lang.startsWith('en')
      ? { load: 'Load YouTube video', play: 'Play video' }
      : { load: 'YouTube-Video laden', play: 'Video abspielen' };

  function mayLoadYouTube() {
    // Pandectes owns the banner; use its effective functionality consent when its API is available.
    const providers = [window.Pandectes, window.Shopify && window.Shopify.customerPrivacy];
    for (const privacy of providers) {
      if (!privacy || typeof privacy.preferencesProcessingAllowed !== 'function') continue;
      try {
        const allowed = privacy.preferencesProcessingAllowed();
        if (typeof allowed === 'boolean') return allowed;
      } catch (error) { /* The banner API may still be initializing. */ }
    }
    return false;
  }

  function embedSource(source) {
    try {
      const url = new URL(source, window.location.href);
      if (!['www.youtube.com', 'youtube.com', 'www.youtube-nocookie.com', 'youtube-nocookie.com'].includes(url.hostname)) return null;
      if (!/^\/embed\/[a-zA-Z0-9_-]+(?:\/|$)/.test(url.pathname)) return null;
      url.protocol = 'https:';
      url.hostname = 'www.youtube-nocookie.com';
      return url.href;
    } catch (error) {
      return null;
    }
  }

  function load(record) {
    if (!record.wrapper.isConnected) return;
    record.frame.setAttribute('src', record.source);
    record.frame.removeAttribute('data-youtube-src');
    record.frame.setAttribute('loading', 'lazy');
    record.frame.setAttribute('allowfullscreen', '');
    record.wrapper.replaceWith(record.frame);
  }

  function suspend(record) {
    if (!record.frame.isConnected) return;
    record.frame.removeAttribute('src');
    record.frame.setAttribute('data-youtube-src', record.source);
    record.frame.replaceWith(record.wrapper);
  }

  function updateConsent() {
    const allowed = mayLoadYouTube();
    records.forEach(function (record) {
      if (!record.frame.isConnected && !record.wrapper.isConnected) {
        records.delete(record);
        return;
      }
      if (previousConsent === true && !allowed) record.manual = false;
      if (allowed || record.manual) load(record);
      else suspend(record);
    });
    previousConsent = allowed;
  }

  function prepareFrame(frame) {
    if (prepared.has(frame)) return;
    const source = embedSource(frame.getAttribute('data-youtube-src'));
    if (!source) return;
    prepared.add(frame);
    const wrapper = document.createElement('div');
    const button = document.createElement('button');
    wrapper.className = 'youtube-click-to-load';
    // Keep absolute positioning used by responsive description/landing-page embeds.
    wrapper.style.cssText = frame.style.cssText;
    button.type = 'button';
    button.textContent = '▶ ' + copy.load;
    button.setAttribute('aria-label', (frame.title || copy.play) + ' – ' + copy.load);
    const record = { frame: frame, wrapper: wrapper, source: source };
    // Preserve the existing explicit, per-video click-to-load option.
    button.addEventListener('click', function () { record.manual = true; load(record); });
    wrapper.appendChild(button);
    records.add(record);
    frame.replaceWith(wrapper);
    if (mayLoadYouTube()) load(record);
  }

  function prepareYouTube(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('iframe[data-youtube-src]')) prepareFrame(root);
    root.querySelectorAll('iframe[data-youtube-src]').forEach(prepareFrame);
  }

  function start() {
    prepareYouTube(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(prepareYouTube);
      });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('visitorConsentCollected', updateConsent);
    document.addEventListener('shopify:section:load', function (event) { prepareYouTube(event.target); });
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', updateConsent);
    document.addEventListener('consentTrackingApiLoaded', updateConsent);
    window.addEventListener('consentTrackingApiLoaded', updateConsent);
    window.addEventListener('PandectesInitialized', updateConsent);
    window.addEventListener('PandectesConsentUpdate', updateConsent);
    window.addEventListener('PandectesConsentUpdateLegacy', updateConsent);
    window.addEventListener('PandectesEvent_OnConsent', updateConsent);
    // Some Pandectes plans do not publish API events. Keep consent changes in sync there too.
    setInterval(updateConsent, 1000);
    window.addEventListener('pageshow', updateConsent);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
        if (!error) updateConsent();
      });
    }
    updateConsent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
